import { Injectable } from '@angular/core';
import { RoomAcl, RoomAclGroups, RoomAclMembers, SecurityService } from '@era/locations-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs/operators';
import {
  RoomPermissionsResolverActions,
  AccessControlListApiActions,
  RoomAclPermissionsUiActions,
} from './room-acl.actions';
import { safeMap } from '../effects.helpers';

@Injectable()
export class RoomAclEffects {
  constructor(
    private readonly securityService: SecurityService,
    private readonly actions$: Actions
  ) {}

  groupLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RoomPermissionsResolverActions.roomAclRequested),
      mergeMap(({ resourceId, floorResourceId, locationResourceId }) =>
        safeMap(
          this.securityService.getRoomAcls(resourceId, floorResourceId, locationResourceId),
          (roomAcl: RoomAcl) => AccessControlListApiActions.roomAclLoaded({ roomAcl }),
          (error) => AccessControlListApiActions.roomAclLoadedError({ error })
        )
      )
    );
  });

  roomAclMemberPutEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RoomAclPermissionsUiActions.roomAclMemberPut),
      mergeMap(({ aclMember }) =>
        this.securityService
          .putRoomAclMembers(aclMember.resourceId, aclMember)
          .pipe(
            map((roomAclMember: RoomAclMembers) =>
              AccessControlListApiActions.roomAclMemberPut({ aclMember: roomAclMember })
            )
          )
      )
    );
  });

  roomAclGroupPutEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RoomAclPermissionsUiActions.roomAclGroupPut),
      mergeMap(({ aclGroup }) =>
        this.securityService
          .putRoomAclGroups(aclGroup.resourceId, aclGroup)
          .pipe(
            map((roomAclGroup: RoomAclGroups) =>
              AccessControlListApiActions.roomAclGroupPut({ aclGroup: roomAclGroup })
            )
          )
      )
    );
  });
}
